import React, {FC, useMemo} from 'react'
import {ProcurementAttachmentDto} from '../core/_models'
import {DocBlock} from './ProcurementDocumentSections'
import ProcurementAttachmentPrintList from './ProcurementAttachmentPrintList'

interface ProcurementAttachmentsSectionProps {
  attachments?: ProcurementAttachmentDto[] | null
  title?: string
}

const STAGE_LABELS: Record<string, string> = {
  REQUISITION: 'Requisition',
  RFQ: 'RFQ',
  QUOTATION: 'Quotation',
  PURCHASE_ORDER: 'Purchase Order',
  GOODS_RECEIPT: 'Goods Receipt',
  INVOICE: 'Invoice',
}

const ProcurementAttachmentsSection: FC<ProcurementAttachmentsSectionProps> = ({
  attachments,
  title = 'Attachments',
}) => {
  const groups = useMemo(() => {
    const grouped = new Map<string, ProcurementAttachmentDto[]>()
    ;(attachments || []).forEach((attachment) => {
      if (!attachment?.fileName) return
      const stage = String(attachment.sourceStage || 'UNKNOWN')
      const bucket = grouped.get(stage) || []
      const registryId = String(attachment.registryId ?? attachment.id ?? '')
      if (!bucket.some((item) => String(item.registryId ?? item.id ?? '') === registryId)) {
        bucket.push(attachment)
      }
      grouped.set(stage, bucket)
    })
    return Array.from(grouped.entries())
  }, [attachments])

  return (
    <DocBlock title={title}>
      {groups.length === 0 ? (
        <div className='text-muted'>No attachments available.</div>
      ) : (
        <div className='d-flex flex-column gap-4'>
          {groups.map(([stage, items]) => (
            <div key={stage}>
              <div className='fw-semibold mb-2'>
                {STAGE_LABELS[stage] || stage}
                {items[0]?.sourceReference ? ` (${items[0].sourceReference})` : ''}
              </div>
              <ProcurementAttachmentPrintList
                attachments={items.map((item) => ({
                  id: item.id,
                  registryId: item.registryId ?? item.id ?? null,
                  attachmentKey:
                    item.registryId != null
                      ? String(item.registryId)
                      : item.id != null
                      ? String(item.id)
                      : null,
                  fileName: item.fileName,
                  sizeBytes: item.size ?? null,
                  url: item.downloadUrl || item.viewUrl || undefined,
                  canView: item.canView ?? true,
                  canDownload: item.canDownload ?? true,
                }))}
              />
            </div>
          ))}
        </div>
      )}
    </DocBlock>
  )
}

export default ProcurementAttachmentsSection
